import { isEmpty } from 'lodash';
import { __experimentalDivider as Divider } from '@wordpress/components';

const {
  i18n: { __ },
  components: { Button, ToggleControl },
  blockEditor: { MediaUpload, MediaUploadCheck, useSettings },
} = wp;

const FileDownload = ({ downloadFile, setAttributes }) => {
  const [fileTypesArray] = useSettings(`custom.global.downloadableFileTypes`);
  const downloadableFileTypes =
    Array.isArray(fileTypesArray) && fileTypesArray.length
      ? fileTypesArray
      : ['image', 'video', 'audio', 'application', 'text'];

  return (
    <>
      <MediaUploadCheck>
        <MediaUpload
          onSelect={(file) => {
            setAttributes({
              downloadFile: {
                id: file.id,
                title: file.title,
                filename: file.filename,
                url: file.url,
                fileType: file.type,
              },
            });
          }}
          allowedTypes={downloadableFileTypes}
          multiple={false}
          render={({ open }) => (
            <>
              {downloadFile && (
                <div className="e-cmp__media-preview">
                  {['image', 'audio'].includes(downloadFile.fileType) ? (
                    <embed src={downloadFile.url} alt={downloadFile.filename} />
                  ) : (
                    <p>{downloadFile.filename}</p>
                  )}
                </div>
              )}
              <div className="e-cmp__media-buttons">
                <Button onClick={open} variant="primary">
                  {isEmpty(downloadFile)
                    ? __('Select a file', 'b3rg')
                    : __('Replace', 'b3rg')}
                </Button>
                {!isEmpty(downloadFile) && (
                  <Button
                    variant="secondary"
                    onClick={() =>
                      setAttributes({
                        downloadFile: {},
                      })
                    }
                  >
                    {__('Remove', 'b3rg')}
                  </Button>
                )}
              </div>
            </>
          )}
        />
      </MediaUploadCheck>
      <Divider />
      <ToggleControl
        label={__('Open in new tab', 'b3rg')}
        checked={downloadFile.opensInNewTab}
        onChange={(opensInNewTab) => {
          setAttributes({
            downloadFile: {
              ...downloadFile,
              opensInNewTab,
            },
          });
        }}
      />
    </>
  );
};

export default FileDownload;
